import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M5 6.5c-.3 0-.5.2-.5.5v6c0 .3.2.5.5.5s.5-.2.5-.5V7c0-.3-.2-.5-.5-.5m2.5.5v6c0 .3.2.5.5.5s.5-.2.5-.5V7c0-.3-.2-.5-.5-.5s-.5.2-.5.5m3.5 6.5c.3 0 .5-.2.5-.5V7c0-.3-.2-.5-.5-.5s-.5.2-.5.5v6c0 .3.2.5.5.5m3.4-11.1C14 2.1 13.5 2 13 2h-1.5c0-1.1-.9-2-2-2h-3c-1.1 0-2 .9-2 2H3c-.5 0-1 .1-1.4.4S1 3.1 1 3.5v1c0 .3.2.5.5.5H2v10.5c0 .3.2.5.5.5h11c.3 0 .5-.2.5-.5V5h.5c.3 0 .5-.2.5-.5v-1c0-.4-.2-.8-.6-1.1M6.5 1h3c.6 0 1 .4 1 1h-5c0-.6.4-1 1-1M13 15H3V5h10zm1-11H2v-.5q0-.15.3-.3c.2-.1.4-.2.7-.2h10c.3 0 .5.1.7.2q.3.15.3.3z" />
  </svg>
);
const SvgTrashCan = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="trash-can" {...props} />;
export default SvgTrashCan;
